import _ from 'lodash';

export default function EDR({ stateInfos }) {
  const universal = [];
  const permanent = [];
  const semiPermanent = [];
  const noExcuse = [];
  const excuseRequired = [];

  stateInfos.forEach((state) => {
    const stateData = _.keyBy(state.nodes, 'field_type');

    const stateMailingBallots =
      stateData.absentee_access_levels.text === 'universal';
    const statePermanent =
      stateData.absentee_access_levels.text === 'permanent';
    const stateSemiPermanent =
      stateData.absentee_access_levels.text === 'semi_permanent';
    const stateNoExcuse = stateData.absentee_access_levels.text === 'no_excuse';

    if (stateMailingBallots) {
      universal.push(state);
    } else if (statePermanent) {
      permanent.push(state);
    } else if (stateSemiPermanent) {
      semiPermanent.push(state);
    } else if (stateNoExcuse) {
      noExcuse.push(state);
    } else {
      excuseRequired.push(state);
    }
  });

  return [
    {
      title: 'Excuse required to vote absentee',
      states: excuseRequired,
    },
    {
      title: 'No-excuse absentee voting',
      states: noExcuse,
    },
    {
      title: 'Semi-permanent absentee voting',
      states: semiPermanent,
    },
    {
      title: 'Permanent absentee voting',
      states: permanent,
    },
    {
      title: 'Universal vote by mail',
      states: universal,
    },
  ];
}
